import React, { useState } from 'react'

const BADGE_TEXT = { fi: 'Aito asiakastarina', en: 'Verified customer story' }

function BrandingLogo({ lang, size }) {
  const logoStyle = { height: `${size}px`, width: 'auto', display: 'block' }

  if (lang === 'en') {
    return <img src={`${process.env.API_ROOT}/widget/loyal-stories.png`} alt="Loyal Stories" style={logoStyle} />
  }

  return (
    <svg stroke-miterlimit="10" style={{fillRule:'nonzero',clipRule:'evenodd',strokeLinecap:'round',strokeLinejoin:'round',...logoStyle}} viewBox="0 0 364.115 43.5744" xmlns="http://www.w3.org/2000/svg"><defs/><clipPath id="ArtboardFrame"><rect height="43.5744" width="364.115" x="0" y="0"/></clipPath><g clipPath="url(#ArtboardFrame)"><g opacity="1"><path d="M332.288 23.1898C332.288 26.4811 337.339 26.4492 337.339 23.1898C337.339 19.8984 332.288 19.8655 332.288 23.1898M355.668 0.440775L340.969 0.440775L340.969 25.5687L345.435 25.5687L345.435 14.879L354.104 14.879L354.104 10.805L345.435 10.805L345.435 4.54673L355.668 4.54673L355.668 0.440775ZM363.958 0.47272L359.428 0.47272L359.428 25.5687L363.958 25.5687L363.958 0.47272Z" fill="#0d3b70" fillRule="nonzero" opacity="1" stroke="none"/><path d="M31.4822 43.1542L16.1645 21.6311L30.1964 0.108064L21.1959 0.108064L9.90325 18.221L7.8348 18.221L7.8348 0.108064L0.120032 0.108064L0.120032 43.1542L7.77889 43.1542L7.77889 25.8799L9.95916 25.8799L22.0903 43.1542L31.4822 43.1542ZM47.5467 43.5456C57.7781 43.5456 62.2495 39.5764 62.2495 30.6876L62.2495 12.4629C62.2495 3.3505 57.9448-0.395073 47.5467-0.395073C37.1495-0.395073 33.1803 3.3505 33.1803 12.4629L33.1803 30.6876C33.1803 39.5764 37.3172 43.5456 47.5467 43.5456M47.5467 36.7253C41.9563 36.7253 40.8941 34.3773 40.8941 30.2963L40.8941 12.8542C40.8941 8.94091 41.9563 6.42523 47.5467 6.42523C53.5294 6.42523 54.5347 8.94091 54.5347 12.8542L54.5347 30.2963C54.5347 34.3773 53.1381 36.7253 47.5467 36.7253M101.459 43.1542L86.1415 21.6311L100.173 0.108064L91.1728 0.108064L79.8802 18.221L77.8118 18.221L77.8118 0.108064L70.097 0.108064L70.097 43.1542L77.7559 43.1542L77.7559 25.8799L79.9361 25.8799L92.0673 43.1542L101.459 43.1542ZM106.342 0.108064L106.342 43.2101L131.89 43.2101L131.89 36.1662L114.057 36.1662L114.057 24.8177L128.592 24.8177L128.592 17.8856L114.057 17.8856L114.057 6.81656L131.107 6.81656L131.107 0.108064L106.342 0.108064ZM155.726 32.9797L164.279 15.6494L163.385 27.9483L163.385 43.1542L171.1 43.1542L171.1 0.108064L163.665 0.108064L154.832 19.1714L146.055 0.108064L138.619 0.108064L138.619 43.1542L146.334 43.1542L146.334 27.9483L145.44 15.6494L153.993 32.9797L155.726 32.9797ZM199.909 30.0168C199.909 34.0978 197.729 36.7253 193.145 36.7253C188.561 36.7253 186.772 34.0978 186.772 30.0168L186.772 0.163968L179.057 0.163968L179.057 30.4081C179.057 39.2968 184.088 43.5456 193.145 43.5456C202.201 43.5456 207.624 39.2968 207.624 30.4081L207.624 0.163968L199.909 0.163968L199.909 30.0168ZM247.057 43.1542L231.74 21.6311L245.772 0.108064L236.771 0.108064L225.478 18.221L223.41 18.221L223.41 0.108064L215.695 0.108064L215.695 43.1542L223.354 43.1542L223.354 25.8799L225.534 25.8799L237.666 43.1542L247.057 43.1542ZM269.663 11.3448L277.433 11.3448C276.707 2.73556 271.563-0.115553 263.793-0.115553C254.96-0.115553 250.04 4.07726 250.04 12.1274C250.04 21.0162 255.184 23.4201 260.047 24.035C264.631 24.65 270.669 24.65 270.669 29.7372C270.669 34.6009 268.545 36.5575 263.905 36.5575C258.985 36.5575 257.531 34.7686 257.364 31.4703L249.593 31.4703C249.593 38.4024 253.003 43.6015 263.737 43.6015C274.079 43.6015 278.384 39.4087 278.384 29.4577C278.384 20.8485 273.632 18.8359 268.656 18.0533C262.116 17.047 257.811 17.4942 257.811 12.0715C257.811 7.99054 259.544 6.64884 263.793 6.64884C267.538 6.64884 269.439 7.71102 269.663 11.3448M293.33 0.163968L285.559 0.163968L285.559 43.2101L293.33 43.2101L293.33 0.163968ZM318.06 0.163968L310.401 0.163968L298.493 43.1542L306.432 43.1542L308.668 35.5513L319.681 35.5513L321.861 43.1542L329.8 43.1542L318.06 0.163968ZM310.569 28.0042L314.146 12.0715L317.724 28.0042L310.569 28.0042Z" fill="#231f20" fillRule="nonzero" opacity="1" stroke="none"/></g></g></svg>
  )
}

function SlidePreview({ slide, isMediaLeft, textColor, accentColor, lang, mediaFiles, t }) {
  const { titleText, contentText, personName, personTitle, company, ctaText, ctaUrl, fileId, imagePosition } = slide
  const selectedMedia = mediaFiles.find(file => file.id === fileId) || null
  const selectedMediaThumbnail = selectedMedia
    ? selectedMedia.thumbnail || (selectedMedia.meta && selectedMedia.meta.thumbnail) || selectedMedia.url || null
    : null
  const isSelectedMediaVideo = selectedMedia
    ? !!(selectedMedia.meta && selectedMedia.meta.type && selectedMedia.meta.type.includes('video'))
    : false
  const metaParts = [personTitle, company].filter(Boolean)

  return (
    <div className={`widget-preview-widget${isMediaLeft ? ' widget-preview-widget--media-left' : ''}`}>
      <div className="widget-preview-text">
        <h2 className="widget-preview-title" style={{ color: textColor }}>{titleText}</h2>
        <p className="widget-preview-body" style={{ color: textColor }}>{contentText}</p>
        <div className="widget-preview-footer">
          <div>
            {personName && <div className="widget-preview-person-name" style={{ color: accentColor }}>{personName}</div>}
            {metaParts.length > 0 && (
              <div className="widget-preview-person-meta">
                {metaParts.map((part, i) => (
                  <span key={i}>{i < metaParts.length - 1 ? part + ', ' : part}</span>
                ))}
              </div>
            )}
          </div>
          {ctaUrl && (
            <a className="widget-preview-cta-btn" style={{ color: accentColor }} href="#" onClick={e => e.preventDefault()}>
              {(ctaText || 'Katso koko tarina') + ' ›'}
            </a>
          )}
        </div>
        {/* Aligned to the opposite side of the branding logo, so the two land on the same row. */}
        <div className="widget-preview-badge-row" style={{ justifyContent: isMediaLeft ? 'flex-end' : 'flex-start' }}>
          <div className="widget-preview-badge" style={{ color: accentColor }}>
            <img className="widget-preview-badge-icon" src={`${process.env.API_ROOT}/widget/kupla.svg`} alt="" />
            <span>{BADGE_TEXT[lang]}</span>
          </div>
        </div>
      </div>
      {/* Video slides are still approximated with a static thumbnail. */}
      <div className={`widget-preview-media${selectedMediaThumbnail ? ' widget-preview-media--image' : ''}`}>
        {selectedMediaThumbnail && (
          <div
            className="widget-preview-media-frame"
            style={{
              backgroundImage: `url(${selectedMediaThumbnail})`,
              backgroundPosition: isSelectedMediaVideo || !imagePosition
                ? '50% 50%'
                : `${imagePosition.x}% ${imagePosition.y}%`,
            }}
          >
            {isSelectedMediaVideo && (
              <div className="widget-preview-video-badge">{t('widget.previewVideo') || 'Video'}</div>
            )}
          </div>
        )}
        <div className="widget-preview-branding" style={{ justifyContent: isMediaLeft ? 'flex-start' : 'flex-end' }}>
          <BrandingLogo lang={lang} size={10} />
        </div>
      </div>
    </div>
  )
}

export default function TabPreview({ slides, layout, maxWidth, titleFontSize, contentFontSize, textColor, accentColor, backgroundColor, mediaFiles, t }) {
  const [index, setIndex] = useState(0)
  const [auto, setAuto] = useState(true)
  // The fi and en embeds differ visually: badge wording and branding logo.
  const [lang, setLang] = useState('fi')
  const total = slides ? slides.length : 0
  const currentIndex = Math.min(index, Math.max(0, total - 1))

  // Same fallbacks the widget applies to the API response.
  const effectiveTextColor = textColor || '#111111'
  const effectiveAccentColor = accentColor || effectiveTextColor
  const isMediaLeft = layout !== 'text-image'
  // Same rule as `parsePixels()` in api/src/routes/dashboard/widget.js and `pixels()` in
  // api/widget/widget.js — keep the three in sync.
  const pixels = value => {
    const parsed = parseInt(value, 10)
    return Number.isFinite(parsed) && parsed > 0 ? `${parsed}px` : null
  }
  const containerStyle = {
    background: backgroundColor,
    maxWidth: pixels(maxWidth) || 'none',
    '--widget-title-font-size': pixels(titleFontSize),
    '--widget-content-font-size': pixels(contentFontSize),
  }

  React.useEffect(() => {
    if (!auto || total <= 1) return
    const timer = setInterval(() => setIndex(i => (i + 1) % total), 5000)
    return () => clearInterval(timer)
  }, [auto, total])

  return (
    <React.Fragment>
      <div className="widget-preview-lang">
        {['fi', 'en'].map(code => (
          <button
            key={code}
            className={`widget-preview-lang-btn${code === lang ? ' widget-preview-lang-btn--active' : ''}`}
            onClick={() => setLang(code)}
          >
            {code.toUpperCase()}
          </button>
        ))}
      </div>
      <div className="widget-preview-container" style={containerStyle}>
        <div className="widget-preview-clip">
          <div className="widget-preview-track" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
            {(slides || []).map((slide, i) => (
              <SlidePreview
                key={i}
                slide={slide}
                isMediaLeft={isMediaLeft}
                textColor={effectiveTextColor}
                accentColor={effectiveAccentColor}
                lang={lang}
                mediaFiles={mediaFiles}
                t={t}
              />
            ))}
          </div>
        </div>
        {total > 1 && (
          <div className="widget-preview-nav" style={{ color: effectiveTextColor }}>
            <button
              className="widget-preview-nav-arrow"
              onClick={() => { setAuto(false); setIndex(i => (i - 1 + total) % total) }}
            >
              ‹
            </button>
            <div className="widget-preview-nav-dots">
              {slides.map((_, i) => (
                <button
                  key={i}
                  className={`widget-preview-nav-dot${i === currentIndex ? ' widget-preview-nav-dot--active' : ''}`}
                  onClick={() => { setAuto(false); setIndex(i) }}
                />
              ))}
            </div>
            <button
              className="widget-preview-nav-arrow"
              onClick={() => { setAuto(false); setIndex(i => (i + 1) % total) }}
            >
              ›
            </button>
          </div>
        )}
      </div>
    </React.Fragment>
  )
}
